import { useLocation } from "react-router-dom";

const SITE_NAME = "van Gelder, Inc.";
const DEFAULT_DESC =
  "van Gelder, Inc. — commercial flooring, entrance matting, custom logo mats, carpet tile, grid systems, and luxury vinyl engineered for performance in every commercial environment.";

// React 19 natively hoists <title>, <meta>, and <link> to <head>.
export const Seo = ({ title, description, image = "/og-image.jpg", type = "website" }) => {
  const { pathname } = useLocation();
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canonical = `${origin}${pathname}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const desc = description || DEFAULT_DESC;
  const absImage = image.startsWith("http") ? image : `${origin}${image}`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={absImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={absImage} />
    </>
  );
};
